export default "__VITE_ASSET__B6E9PpJY__"